import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable, Optional, SkipSelf } from '@angular/core';
import { IssueBase, IssueType, IssueWebNotifications } from 'src/lib/fliko/models/defects/issue.base';
import { IssueService } from 'src/app/view/defects/service/issue.service';
import { IssueBaseVM } from 'src/app/view/defects/service/models/defect-view-models';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { DbCollection, NulCol } from './database/dbCollection';
import { DatabaseService } from './database.service';
import { Sound, SoundService } from './sound.service';

// TODO refactor

@Injectable({
  providedIn: 'root'
})
export class WebNotificationService {
  private oldDefectsNtf?: IssueWebNotifications;
  private oldConciergeNtf?: IssueWebNotifications;

  constructor(
    private ctxDS: ContextDataService,
    private dbSrv: DatabaseService,
    private issueService: IssueService,
    private soundService: SoundService,
    @Optional() @SkipSelf() thisService?: WebNotificationService
  ) {
    if (thisService) throw new Error('Multiple instances of WebNotificationService');
  }

  /**
   * @path /webNotification/defect/$estateId/
   * @key defectId
   */
  private get defectNtf() {
    return this.dbSrv.estateFactory.getCollection<IssueWebNotifications>('webNotification/defect/$eId');
  }

  /**
   * @path /webNotification/concierge/$estateId/
   * @key taskId
   */
  private get conciergeNtf() {
    return this.dbSrv.estateFactory.getCollection<IssueWebNotifications>('webNotification/concierge/$eId');
  }

  public getDefectNtf$(): Observable<IssueWebNotifications> {
    return this.getIssueNtf$(this.defectNtf.getObject(), this.issueService.getDefects$(), this.oldDefectsNtf);
  }

  public getConciergeNtf$(): Observable<IssueWebNotifications> {
    return this.getIssueNtf$(this.conciergeNtf.getObject(), this.issueService.getTasks$(), this.oldConciergeNtf);
  }

  private getIssueNtf$(
    ntf$: Observable<NulCol<IssueWebNotifications>>,
    issues$: Observable<IssueBase[]>,
    oldNtf?: IssueWebNotifications
  ): Observable<IssueWebNotifications> {
    return combineLatest([this.ctxDS.currentUser$, ntf$, issues$]).pipe(
      map(([user, ntf, issues]) => {
        const filtered: IssueWebNotifications = {};
        if (ntf) {
          issues.forEach((issue) => {
            if (ntf[issue.id] && (!issue.assignedUserId || issue.assignedUserId == user?.id)) {
              filtered[issue.id] = true;
              if (oldNtf && !oldNtf[issue.id]) this.soundService.play(Sound.PING);
            }
          });
          oldNtf = { ...filtered };
        }
        return filtered;
      })
    );
  }

  public async clearIssueNotification(vm: IssueBaseVM): Promise<void> {
    await this.getIssueCollection(vm.dataType)?.removeElement(vm.data.id);
  }

  public async clearIssueNotifications(type: IssueType): Promise<void> {
    await this.getIssueCollection(type)?.setObject({});
  }

  private getIssueCollection(type: IssueType): DbCollection<IssueWebNotifications> | null {
    return type === IssueType.ISSUE ? null : this[`${type}Ntf`];
  }
}
